export default function Nav() {
  return (
      <nav id="main-nav">
        <a href="tel:+1-210-501-9271">+1-210-501-9271</a>

        <a href="mailto:paul88vera@gmail.com">paul88vera@gmail.com</a>

        <a href="mailto:paul88vera@gmail.com" className="email-box">
          <i className="fa-solid fa-envelope"></i>
        </a>
      </nav>
  );
}
